import type { SVGProps } from "react";
export interface ToothShieldCheckIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ToothShieldCheckIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ToothShieldCheckIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M23.113 8.888a1.125 1.125 0 0 1-2.246-.13zM20.875 8.5c0-1.548-.444-2.912-1.196-3.865-.732-.927-1.786-1.51-3.178-1.51-.69 0-1.597.368-2.442.851l-.036.02 1.601 1.068.093.07a1.126 1.126 0 0 1-1.242 1.861l-.098-.058-3-2.001-.08-.058-.001-.001-.016-.012-.07-.054c-.064-.048-.159-.12-.28-.205a13 13 0 0 0-.988-.63c-.845-.483-1.752-.85-2.442-.851-1.392 0-2.447.583-3.18 1.51-.751.953-1.195 2.317-1.195 3.865 0 .555.13 1.395.375 2.444.24 1.03.576 2.196.948 3.375a114 114 0 0 0 2.141 6.091l.047.1c.127.22.367.364.643.364.3 0 .573-.175.696-.45l.362-.803a1.126 1.126 0 0 1 2.052.923l-.362.804a3.01 3.01 0 0 1-2.748 1.777 2.98 2.98 0 0 1-2.7-1.698l-.092-.214a116 116 0 0 1-2.185-6.217 50 50 0 0 1-.993-3.54C1.055 10.368.875 9.323.875 8.5c0-1.952.557-3.837 1.68-5.26C3.698 1.794 5.393.876 7.5.876c1.311 0 2.654.631 3.559 1.148.362.207.68.416.94.592.26-.176.58-.384.943-.592C13.847 1.506 15.19.875 16.5.875c2.107 0 3.803.918 4.946 2.366 1.123 1.422 1.678 3.307 1.678 5.259q0 .19-.011.388l-1.124-.066-1.122-.065a4 4 0 0 0 .008-.257"
      />
      <path
        fill={color}
        d="m20.874 14.015-3.625-1.837-3.624 1.837v2.653l.005.15c.064.748.603 1.575 1.474 2.391.753.706 1.606 1.26 2.145 1.58.538-.32 1.392-.873 2.146-1.58.928-.87 1.479-1.754 1.479-2.541zm-2.57.44a1.125 1.125 0 1 1 1.591 1.59l-2.422 2.423a1.126 1.126 0 0 1-1.591 0l-1.077-1.076-.078-.085a1.125 1.125 0 0 1 1.583-1.584l.086.078.281.281zm4.82 2.213-.013.327c-.13 1.614-1.206 2.946-2.178 3.857a15 15 0 0 1-2.309 1.738l-.524.31a1.73 1.73 0 0 1-1.498.098L16.4 22.9c-.554-.312-1.755-1.04-2.833-2.05-.972-.912-2.048-2.242-2.178-3.856l-.014-.327v-2.92c0-.678.38-1.308.992-1.618l4.071-2.063.196-.085a1.8 1.8 0 0 1 1.232 0l.197.085 4.07 2.063.22.132c.483.338.772.893.772 1.486v2.92Z"
      />
    </svg>
  );
}
